import { AchievementGuestData } from "./types"

export const achievementsSerializer = (data: any[]) => {
  return data.map((ach) => ({
    id: ach.id,
    type: ach.type,
    name: ach.name,
    shortDescription: ach.short_description,
    fullDescription: ach.full_description,
    isArchived: ach.is_archived
  })) as AchievementGuestData[]
}
